var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row roomy align-stretch" }, [
    _vm.isNewAccount
      ? _c(
          "div",
          {
            staticClass:
              "column-12 tablet:column-6 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0",
          },
          [
            _c(
              "article",
              {
                staticClass: "card",
                staticStyle: { height: "100%" },
                attrs: { id: "accounts" },
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "padding-2xs",
                  style: `color: var(--fa-dk-${_vm.theme});`,
                  attrs: {
                    icon: _vm.$v6.solid.faUser,
                    size: "3x",
                    "fixed-width": "",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-left size-sm" }, [
                  _c("h3", { staticClass: "h4 margin-top-lg" }, [
                    _vm._v("Ahhh! That New Account Smell."),
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v(
                        "\n          Along with this purchase, we also created\n          "
                      ),
                      _c("site-link", { attrs: { to: { name: "account" } } }, [
                        _vm._v("a Font Awesome Account"),
                      ]),
                      _vm._v(
                        "\n          for you to make managing your subscription, features, and details over time easier.\n        "
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "column-12 tablet:column-6 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0",
      },
      [
        _c(
          "article",
          {
            staticClass: "card",
            staticStyle: { height: "100%" },
            attrs: { id: "invoices" },
          },
          [
            _c("font-awesome-icon", {
              staticClass: "padding-2xs",
              style: `color: var(--fa-dk-$(theme));`,
              attrs: {
                icon: _vm.$v6.solid.faReceipt,
                size: "3x",
                "fixed-width": "",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "text-left size-sm" }, [
              _c("h3", { staticClass: "h4 margin-top-lg" }, [
                _vm._v("Invoices & Receipts"),
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _vm._v("\n          You can find\n          "),
                  _c(
                    "site-link",
                    { attrs: { to: { name: "account.billing" } } },
                    [_vm._v("a print-friendly invoice of this purchase")]
                  ),
                  _vm._v(
                    "\n          in the Billing section of your Account. Add extra information (business address, VAT number, etc.) to the invoice by viewing it.\n        "
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "column-12 tablet:column-6 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0",
      },
      [
        _c(
          "article",
          {
            staticClass: "card",
            staticStyle: { height: "100%" },
            attrs: { id: "questions" },
          },
          [
            _c("font-awesome-icon", {
              staticClass: "padding-2xs",
              style: `color: var(--fa-dk-${_vm.theme});`,
              attrs: {
                icon: _vm.$v6.solid.faHeadset,
                size: "3x",
                "fixed-width": "",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "text-left size-sm" }, [
              _c("h3", { staticClass: "h4 margin-top-lg" }, [
                _vm._v("Have a Question or Need Help?"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Is something about this order confusing or mistaken? We're here to help.\n          "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "mailto:hello@fontawesome.com?subject=I need help with a purchase that was made, Font Awesome!",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.supportLinkClicked(
                          "commission_success_view, footer"
                        )
                      },
                    },
                  },
                  [_vm._v("Get in touch")]
                ),
                _vm._v("\n          and let us know the details.\n        "),
              ]),
            ]),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }